import { RESET_ALL as RESET_ON_LOGOUT, danger } from 'redux-store/reducers/common-reducer';

import { createReducer } from 'utils/redux';
import { API, get } from 'utils/api';
import { logError } from 'utils/log';
import { __t, applyTranslations } from 'utils/language';

import type {
  Action,
  Dispatch,
  RecentsActionType,
  RecentsResourceType,
  RecentsResult,
  ThunkAction
} from 'types';

applyTranslations(require('./recents-reducer.i18n.json'));

const { RECENTS } = API.END_POINTS;

const LOADING = 'recents/LOADING';
const LOADED = 'recents/LOADED';
const RESET = 'recents/RESET';

type State = {
  results: Array<RecentsResult>,
  isLoading: boolean
};

const initialState: State = {
  results: [],
  isLoading: false
};

const MSG_KEY = 'recents';

const recentsLoaded = (results: Array<RecentsResult>): Action => ({
  type: LOADED,

  payload: {
    results
  }
});

const recentsLoading = (isLoading: boolean): Action => ({
  type: LOADING,

  payload: {
    isLoading
  }
});

export const resetRecents = (): Action => ({
  type: RESET
});

export const fetchRecents = (
  resourceType: RecentsResourceType,
  orgId: number,
  creatorId: number,
  actionType: RecentsActionType
): ThunkAction => async (dispatch: Dispatch) => {
  dispatch(recentsLoading(true));

  try {
    const url = RECENTS.getRecents(resourceType, orgId, creatorId);
    const results = await get(url, {}, { suppressGlobalNotification: true });

    dispatch(recentsLoading(false));
    dispatch(recentsLoaded(results.data));
  } catch (e) {
    logError(e);
    dispatch(danger(__t(`${MSG_KEY}.messages.load_error`, {
      resourceType: __t(`${MSG_KEY}.messages.types.${actionType}`)
    })));
  } finally {
    dispatch(recentsLoading(false));
  }
};

export default createReducer<State, any>('recents', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [RESET]: () => initialState,
  [LOADING]: (state, { isLoading }) => ({
    ...state,
    isLoading
  }),
  [LOADED]: (state, { results }) => ({
    ...state,
    results,
    isLoading: false
  })
});
